(function() {
    'use strict';

    angular
        .module('soopkitchenApp')
        .controller('ObservationDefinitionsDetailController', ObservationDefinitionsDetailController);

    ObservationDefinitionsDetailController.$inject = [ 'ObservationDefinitions', 'previousState',  'SoopkitchenUtils','$stateParams'];

    function ObservationDefinitionsDetailController(ObservationDefinitions, previousState,  SoopkitchenUtils,$stateParams) {
        var vm = this;

        /**** Properties ****/

        vm.waiting = true;
        vm.observationDefinitions = null;
        vm.previousState = null;
        vm.flows = [];
        vm.flushes = [];
        vm.volumes = [];
        vm.flowMappings = [];
        vm.flushMappings = [];
        vm.observationsPerInstrument = null;
        vm.previousState = previousState.name;
        
        /**** Methods ****/

        vm.formatExpression = formatExpression;
        vm.getMapLength = getMapLength;
        vm.sortTable = sortTable;


        ObservationDefinitions.getObservationDefinition($stateParams.id, init, showError);

        function init(response) {
            
            vm.observationDefinitions = response.data;

            vm.flows = createSortedArray(vm.observationDefinitions.derivedFlows.flows, 'id');
            vm.flushes = createSortedArray(vm.observationDefinitions.derivedFlows.flushes, 'id');
            vm.volumes = createSortedArray(vm.observationDefinitions.derivedFlows.volumes, 'id');

            vm.flowMappings = createSortedArray(vm.observationDefinitions.epsActionMappings.flowMappings, 'flowName');
            vm.flushMappings = createSortedArray(vm.observationDefinitions.epsActionMappings.flushMappings, 'flushName');

            vm.observationsPerInstrument = vm.observationDefinitions.allExperimentsObservationDefinitions;
            vm.waiting = false;

        }

        function showError(response) {
            SoopkitchenUtils.prettyError(response, function () {
                vm.waiting = false;
                $scope.$apply();
            });
        }

        function getMapLength(obj) {
            return Object.keys(obj).length;
        }
        
        function formatExpression(str) {
            if (str) {
                return str.replace(/&&/g, ' && ').replace(/\|\|/g, ' || ').replace(/==/g, ' == ').replace(/\+/g, ' + ').replace(/-/g, ' - ').replace(/\*/g, ' * ').replace(/\//g, ' / ');
            }
        }

        function sortTable(table, columnName, reverse) {
            return SoopkitchenUtils.sort(table, columnName, reverse);
        }
        
        function createSortedArray(map, sortKey) {
            return sortTable(SoopkitchenUtils.extractArrayFromMap(map, sortKey), sortKey, false);
        }
    }
})();
